import { updateWhenLocaleChanges } from "@lit/localize";
import { css, html, LitElement } from "lit";
import { LINKS } from "../configuration/constants.js";
import { defineComponent } from "../configuration/utils.js";
import { buttonDefaults, mediumButton, tertiaryButton } from "./styles.js";
export class SignInButton extends LitElement {
    constructor() {
        super();
        this.login = "";
        updateWhenLocaleChanges(this);
    }
    render() {
        const loginUrl = this.login;
        if (loginUrl === undefined || loginUrl.length === 0) {
            return;
        }
        return html `
      <button class="tertiary medium" @click=${() => this.signIn(loginUrl)}>
        <span>${LINKS.LOGIN.label()}</span>
      </button>
    `;
    }
    signIn(url) {
        window.location.href = url;
    }
}
SignInButton.properties = {
    login: { type: String, reflect: true, attribute: "login" },
};
SignInButton.styles = [
    buttonDefaults,
    tertiaryButton,
    mediumButton,
    css `
      :host {
        display: contents;
      }
    `,
];
export const SIGN_IN_BUTTON_TAG = "atlas-gn-sign-in-button";
defineComponent(SIGN_IN_BUTTON_TAG, SignInButton);
